import { AxiosError } from 'axios'
import { FC } from 'react'

import { useSelectedProjectPremises } from '@/api/models/main/hooks/useSelectedProjectPremises'
import { RequestByIdApiType } from '@/api/models/requests'
import { ServerValidationError } from '@/api/shared/types'
import { PageType } from '@/components/entities/requests/model/types'
import { Comments } from '@/components/entities/requests/ui/RequestDetails/Comments/Comments'
import Content from '@/components/entities/requests/ui/RequestDetails/Content/Content'
import ContentHeader from '@/components/entities/requests/ui/RequestDetails/Content/ContentHeader'
import { useRequestNavigation } from '@/components/widgets/request/hooks/useRequestNavigation'

type Props = {
  request: RequestByIdApiType
  pageType: PageType
  refetchRequest: () => void
  onPayClick: () => void
  onFormError: (error: AxiosError<ServerValidationError>) => void
  onCancelSuccess: () => void
}

const RequestDetails: FC<Props> = ({
  request,
  pageType,
  refetchRequest,
  onPayClick,
  onFormError,
  onCancelSuccess
}) => {
  const { shouldShowComments } = useRequestNavigation()

  const { premises } = useSelectedProjectPremises()

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <ContentHeader
        request={request}
        pageType={pageType}
        onPayClick={onPayClick}
        refetchRequest={refetchRequest}
        onFormError={onFormError}
      />
      {shouldShowComments && (
        <Comments
          request={request}
          requestId={request.id}
          refetchRequest={refetchRequest}
          className="min-h-0 flex-grow"
        />
      )}
      {!shouldShowComments && (
        <Content
          request={request}
          pageType={pageType}
          premises={premises}
          onCancelSuccess={onCancelSuccess}
        />
      )}
    </div>
  )
}

export { RequestDetails }
